module.exports = __webpack_public_path__ + "assets/img/26796c94397fcd1c405de937c34665d2.png";